class DrillingRecord {
  constructor(data, config) {
    this.abstract = data.abstract
    this.acres = data.acres
    this.amend = data.amend
    this.amendReason = data.amend_reason
    this.apiNumber = data.api_number
    this.approvalDate = data.approval_date
    this.attachmentUrl = config.drillingAttachmentEndpoint + data.api_number
    this.block = data.block
    this.bopd = data.bopd
    this.bottomHoleCounty = data.bottom_hole_county
    this.bottomHoleNearestLeaseLines = data.bottom_hole_nearest_lease_lines
    this.bottomHoleRange = data.bottom_hole_range
    this.bottomHoleSection = data.bottom_hole_section
    this.bottomHoleTownship = data.bottom_hole_township
    this.bwpd = data.bwpd
    this.classification = data.classification
    this.completionDate = data.completion_date
    this.county = data.county
    this.district = data.district
    this.drillingCompletedDate = data.drilling_completed_date
    this.effectiveDate = data.effective_date
    this.filedDate = data.filed_date
    this.firstProductionDate = data.first_production_date
    this.firstSalesDate = data.first_sales_date
    this.formationCode = data.formation_code
    this.formations = data.formations
    this.horizontalWell = data.horizontal_well
    this.imaged = data.imaged
    this.initialTestDate = data.initial_test_date
    this.leaseName = data.lease_name
    this.legal = data.legal
    this.mcfpd = data.mcfpd
    this.meridian = data.meridian
    this.oldOperator = data.old_operator
    this.operator = data.operator
    this.operatorNum = data.operator_num
    this.originalWellName = data.original_well_name
    this.originalWellNumber = data.original_well_number
    this.purposeOfFiling = data.purpose_of_filing
    this.quartOfBhl = data.quart_of_bhl
    this.quarterCalls = data.quarter_calls
    this.range = data.range
    this.recomplete = data.recomplete
    this.recompletionDate = data.recompletion_date
    this.reentry = data.reentry
    this.rrcGasIdOrLeaseNum = data.rrc_gas_id_or_lease_num
    this.scanDate = data.scan_date
    this.section = data.section
    this.slantWell = data.slant_well
    this.source = data.source
    this.sourceUrl = data.source_url
    this.spud = data.spud
    this.spudDate = data.spud_date
    this.state = data.state
    this.survey = data.survey
    this.totalDepth = data.total_depth
    this.township = data.township
    this.typeOfDocument = data.type_of_document
    this.typeOfProduction = data.type_of_production
    this.vaultDataId = data.vaultDataId
    this.wellName = data.well_name
    this.wellNum = data.well_num
    this.wellType = data.well_type
    this.wellboreProfile = data.wellbore_profile
    this.workover = data.workover
  }
}

export default DrillingRecord
